export const environment = {
  production: false,
  // userDevUrl: 'https://zxkbbj3pcy.us-east-1.awsapprunner.com/api',
  userBaseUrl: 'https://zxkbbj3pcy.us-east-1.awsapprunner.com/api',
  userMgtUrl: 'https://d2xhgoo376k0s0.cloudfront.net/login/learning',
  paymentUrl: 'https://payment-dev.tsin.ca',
  // paymentUrl: 'http://localhost:4400',
  learningBaseUrl: 'https://learndev-be.tsin.ca/api',
  authBaseUrl: 'https://zxkbbj3pcy.us-east-1.awsapprunner.com/api',
  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
  oldApiUrl: 'https://portalstage-be.tsin.ca/api/',
  wsBaseUrl: 'https://learn-test-be.tsin.ca',
  recaptchaSiteKey: '6LeGUecqAAAAAG7TT48TUcRNZTvZn7bTlZC9W5FP',
  jiraLink: 'https://tsin.atlassian.net/servicedesk/customer/portal/8'
};
